import { Box, Heading, Link, Flex, Text } from "@chakra-ui/react";
import { ExternalLinkIcon } from '@chakra-ui/icons';

const ContactsBlock = () => {
    // Roles, not shades: the token layer switches them with the colour mode.
    // Headings and links are normal-size brand text, so brand.solid (5.42:1 on
    // the card in light; blue.500 was 3.9:1) — and they sit on the card, never
    // on the bare page (rule 7).
    const boxBgColor = "bg.surface";
    const textColor = "text.primary";
    const headingColor = "brand.solid";
    const linkColor = "brand.solid";

    return (
        <Flex direction="column" p={8} bg={boxBgColor} borderRadius="md" boxShadow="md" maxW="800px" mx="auto" mt={10}>
            <Box mb={8} p={5} bg={boxBgColor} borderRadius="md" boxShadow="lg">
                <Heading as="h5" size='md' mb={4} color={headingColor}>Contact Support</Heading>
                <Text mb={2} color={textColor}>If you need any assistance, please reach out to our support team.</Text>
                <Text mb={2} color={textColor}>Email: <Link href='mailto:support@ipscore.app' color={linkColor}>support@ipscore.app</Link></Text>
            </Box>
            <Box mb={8} p={5} bg={boxBgColor} borderRadius="md" boxShadow="lg">
                <Heading as="h5" size='md' mb={4} color={headingColor}>Telegram Contacts</Heading>
                <Box mb={6}>
                    <Heading as="h6" size='sm' mb={2} color={headingColor}>Support</Heading>
                    <Text mb={2} color={textColor}>Get in touch with our support team via Telegram.</Text>
                    <Link href='https://t.me/Jumper25' isExternal color={linkColor} display="flex" alignItems="center">
                        IP Score Checker - contact support <ExternalLinkIcon mx='2px' />
                    </Link>
                </Box>
                <Box mb={6}>
                    <Heading as="h6" size='sm' mb={2} color={headingColor}>News Channel</Heading>
                    <Text mb={2} color={textColor}>Join our Telegram news channel to stay updated with the latest news.</Text>
                    <Link href='https://t.me/ipscore_news' isExternal color={linkColor} display="flex" alignItems="center">
                        IP Score Checker - news channel <ExternalLinkIcon mx='2px' />
                    </Link>
                </Box>
                <Box>
                    <Heading as="h6" size='sm' mb={2} color={headingColor}>Chat</Heading>
                    <Text mb={2} color={textColor}>Join our community chat to discuss and get help from other users.</Text>
                    <Link href='https://t.me/joinchat/SJfMp7txZOKZhEnm' isExternal color={linkColor} display="flex" alignItems="center">
                        IP Score Checker - chat <ExternalLinkIcon mx='2px' />
                    </Link>
                </Box>
                <Box mt={6}>
                    <Heading as="h6" size='sm' mb={2} color={headingColor}>Bot</Heading>
                    <Text mb={2} color={textColor}>Use our Telegram bot for quick access to IP Score Checker services.</Text>
                    <Link href='https://t.me/ipscore_bot' isExternal color={linkColor} display="flex" alignItems="center">
                        IP Score Checker - bot <ExternalLinkIcon mx='2px' />
                    </Link>
                </Box>
            </Box>
        </Flex>
    );
}

export default ContactsBlock;
